import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

interface SchedulingLinkBoxedInputWrapperProps {}

/*
 * Style.
 */

const StyledBoxWrapperDiv = styled.div`
  position: relative;
  min-width: 0px;

  > div > div {
    margin: 0px;
  }
`;

/*
 * Component.
 */

export const SchedulingLinkBoxedInputWrapper: FC<PropsWithChildren<SchedulingLinkBoxedInputWrapperProps>> = (
  props,
) => <StyledBoxWrapperDiv>{props.children}</StyledBoxWrapperDiv>;
